export default "__VITE_ASSET__BqzsCH_x__"